export default __webpack_public_path__ + "static/media/back.186668f8.svg";